export default "__VITE_ASSET__oxuO59JS__"